import React from 'react';

interface UserGuideLinkProps {
  UserGuideLabel: string;
}

export const UserGuideLink = ({ UserGuideLabel }: UserGuideLinkProps) => {
  return (
    <a
      href={process.env.PUBLIC_URL + '/GuideSimplifié.pdf'}
      target="_blank"
      rel="noopener noreferrer"
      download="Pharmagarde-Guide-Utlisateur.pdf"
    >
      <u>{UserGuideLabel}</u>
    </a>
  );
};
